import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import Dropdown from "react-bootstrap/Dropdown";
import Pagination from "react-bootstrap/Pagination";
import CommonDashBoard from "../Common/CommonDashBoard";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteUser,
  DowanloadUserxlsv,
  Dowanloadserviceprovider,
  maangeuseraction,
  usermanagement,
  verifyServiceprovider,
} from "../Redux/Actions/AdminActions";
import * as XLSX from "xlsx";
import SearchBar from "../Common/Searchbar";
import PaginationComponet from "../Components/Layout/Pagination";
import placeholder from "../Assets/Images/Road-assistance-placehodler.png";
import { Button, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { toast } from "react-toastify";

export default function UserVerification() {
  const { alldata, loading, error, param } = useSelector(
    (state) => state.usermgt
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const url = process.env.REACT_APP_FILE_BASE_URL;

  const [showd, setshowd] = useState(false);
  const [showverify, setshowVerify] = useState(false);
  const [limit, setlimit] = useState(10);

  const [flag, setflag] = useState(true);
  const [userid, setUserid] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [activePopoverId, setActivePopoverId] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [Role, setrole] = useState("1");

  let location = useLocation()
  const pageNo = new URLSearchParams(location?.search).get("page");

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    navigate(`/user-verification?page=${pageNumber}`)
  };

  useEffect(() => {
    const searchData = {
      page: pageNo,
      limit: limit,
      search: searchValue,
      role: Role,
    };
    dispatch(usermanagement(searchData));
  }, [pageNo, limit, searchValue, flag, Role, dispatch]);

  const fetchDataAndExportToExcel = useCallback(async () => {
    const searchData = {
      page: pageNo,
      role: Role,
    };
    try {
      const response = await dispatch(Dowanloadserviceprovider(searchData));

      const allData = response?.payload?.data?.data?.users;

      const ws = XLSX.utils.json_to_sheet(allData);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      XLSX.writeFile(wb, "exported_data.xlsx", {
        bookType: "xlsx",
        bookSST: false,
        type: "blob",
      });
    } catch (error) {
      console.error("Error fetching or exporting data:", error);
    }
  }, [dispatch, pageNo, Role]);

  const handleDeleteUSer = () => {
    dispatch(DeleteUser({ id: userid }))
      .then((res) => {
        if (res?.payload?.data?.status === 200) {
          toast?.success(res?.payload?.data?.message);
          setshowd(false);
          setflag(!flag);
        }
      })
      .catch((err) => {
        console.log(err, "err Occur");
      });
  };


  const handleVerifyuser = () => {
    dispatch(verifyServiceprovider({ userId: userid, type: 1 }))
      .then((res) => {
        if (res?.payload?.data?.status === 200) {
          toast?.success(res?.payload?.data?.message);
          setshowVerify(false);
          setflag(!flag);
        }
      })
      .catch((err) => {
        console.log(err, "err Occur");
      });
  };

  const ActiveOrDeactivate = (userid, status) => {
    dispatch(maangeuseraction({ userId: userid, type: status }))
      .then((res) => {
        if (res?.payload?.data?.status === 200) {
          toast.success(res?.payload?.data?.message);
          setActivePopoverId(null);
          setflag(!flag);
        }
      })
      .catch((error) => {
        console.log(error, "Error occurred");
      });
  };

  const handleTogglePopover = (id) => {
    setActivePopoverId((prevId) => (prevId === id ? null : id));
  };

  const popover = (id) => {
    return (
      <Popover id="popover-basic" style={{ cursor: "pointer" }}>
        <Popover.Body>
          <p onClick={() => ActiveOrDeactivate(id, 1)}>Active</p>
          <p onClick={() => ActiveOrDeactivate(id, 0)}>Suspend</p>
        </Popover.Body>
      </Popover>
    );
  };

  return (
    <Layout>
      <Container fluid>
        {/* <CommonDashBoard /> */}
      </Container>

      <Container fluid>
        <div className="filters">
          <div className="inner-filter-field">
            <div className="user-search">
              <div className="drop-down">
                <div className="select-box">
                  <Form.Select
                    aria-label="Default select example"
                    name="limit"
                    onChange={(e) => setlimit(e.target.value)}
                  >
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                  </Form.Select>
                </div>
              </div>
              <div className="search-tab">
                <div className="input-search">
                  <Form>
                    <Form.Group controlId="formBasicPassword">
                      <SearchBar setSearchValue={setSearchValue} />
                    </Form.Group>
                  </Form>
                </div>
                <div className="export-box" onClick={fetchDataAndExportToExcel}>
                  <p>
                    <span>
                      <img
                        src={require("../Assets/Images/upload.svg").default}
                      />
                    </span>
                    Export
                  </p>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <Table size="sm" className="table-cmn">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>
                      <div className="user-checkbox">
                        <div className="remember-check"></div>
                        User
                      </div>
                    </th>
                    <th>Role</th>
                    <th>Contact</th>
                    <th>Location </th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {alldata?.data?.users.map((res, index) => {
                    const dynamicIndex = (pageNo - 1) * limit + (index + 1);
                    return (
                      <tr key={index}>
                        <td>{dynamicIndex}</td>
                        <td>
                          <div className="first-user">
                            <div className="remember-check"></div>
                            <div className="user-profile">
                              {res?.profileImage ? (
                                <img src={`${url}${res?.profileImage}`} />
                              ) : (
                                <img src={placeholder} />
                              )}
                              <div className="user-id">
                                <Link
                                  to={`/service-verification-details/${res?._id}`}
                                >
                                  <p>{res?.name || "N/A"}</p>
                                </Link>
                                <span>{res?.email || "N/A"}</span>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="user-role">
                            <p>
                              <span>
                                {res?.role === 1 ? (
                                  <img
                                    src={
                                      require("../Assets/Images/crown.svg")
                                        .default
                                    }
                                  />
                                ) : null}
                              </span>
                              {res?.role === 1 ? "Service Provider" : null}
                            </p>
                          </div>
                        </td>
                        <td>
                          {" "}
                          <div className="cont-num">
                            {" "}
                            {res?.countryCode && res?.phoneNumber
                              ? `${res?.countryCode} ${res?.phoneNumber}`
                              : res?.countryCode
                                ? `${res?.countryCode}`
                                : res?.phoneNumber
                                  ? `${res?.phoneNumber}`
                                  : "N/A"}{" "}
                          </div>
                        </td>
                        <td>
                          <div className="debit">{res?.bussinessAddress || "N/A"}</div>
                        </td>
                        <td>
                          <div className="debit">{res?.createdAt ? new Date(res?.createdAt).toLocaleDateString() : "N/A"}</div>
                        </td>
                        <td>
                          <div
                            className={`${res?.isActive === 1 ? "active" : "pending"
                              }`}
                          >
                            <p>
                              {" "}
                              {res?.isActive === 1 ? "Active" : "Suspended"}
                            </p>
                          </div>
                        </td>
                        <td>
                          <div className="action user-verification">
                            <div className="more-icon">
                              <OverlayTrigger
                                trigger="click"
                                show={activePopoverId === res._id}
                                placement="bottom"
                                overlay={popover(res?._id)}
                                onToggle={() => handleTogglePopover(res._id)}
                                rootClose
                              >
                                <img
                                  src={
                                    require("../Assets/Images/options.svg")
                                      .default
                                  }
                                  alt="Options"
                                  style={{ cursor: "pointer" }}
                                />
                              </OverlayTrigger>
                            </div>

                            <img
                              style={{ cursor: "pointer" }}
                              src={
                                require("../Assets/Images/delete-icon.svg")
                                  .default
                              }
                              onClick={() => {
                                setshowd(true);
                                setUserid(res?._id);
                              }}
                            />

                            <img
                              style={{ cursor: "pointer" }}
                              src={
                                require("../Assets/Images/check.svg").default
                              }

                              onClick={() => { setshowVerify(true); setUserid(res?._id) }}
                            />
                            <Link
                              to={`/service-verification-details/${res?._id}`}>
                              {" "}
                              <img
                                className="bg-success"
                                src={
                                  require("../Assets/Images/view-icon.svg")
                                    .default
                                }
                              />
                            </Link>
                          </div>
                        </td>
                      </tr>
                    );
                  })}

                </tbody>
              </Table>
              <div className="pagination-section">
                <div className="showing-user">
                  <p>
                    Showing {1 + (pageNo - 1) * limit} -
                    {Math.min(pageNo * limit, alldata?.data?.totalCount)}{" "}
                    of {alldata?.data?.totalCount} results
                  </p>

                </div>
                <div className="pagination-block">
                  <PaginationComponet
                    currentPage={pageNo}
                    totalCount={alldata?.data?.totalCount}
                    limit={limit}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="made-with">
          <div className="pixinvent">
            <p>
              {" "}
              © {new Date().getFullYear()}, Made with ❤️ by <span>Codobux</span>
            </p>
          </div>
          {/* <div className="bottom-links">
            <Link to="/">License</Link>
            <Link to="/">More Themes</Link>
            <Link to="/">Documentation</Link>
            <Link to="/">Support</Link>
          </div> */}
        </div>
      </Container>

      <Modal show={showd} animation={false} className="delete-popup">
        <Modal.Body className="text-center">
          <h4 className="are-sure-text">
            Are you sure you want to Delete this user?
          </h4>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-none">
          <Button className="theme-btn" onClick={handleDeleteUSer}>
            Yes
          </Button>
          <Button className="theme-btn" onClick={() => setshowd(false)}>
            No
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showverify} animation={false} className="delete-popup">
        <Modal.Body className="text-center">
          <h4 className="are-sure-text">
            Are you sure you want to verify this user?
          </h4>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-none">
          <Button className="theme-btn" onClick={handleVerifyuser}>
            Yes
          </Button>
          <Button className="theme-btn" onClick={() => setshowVerify(false)}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </Layout >
  );
}
